import ToastManager from "./classess/ToastManager"



window.addEventListener('chat-scroll-bottom', e => {
    console.log('bottom event: room id => ' + e.roomId)
    if (window.livewire) {
        window.livewire.emit('ChatBottom', { chatType : e.roomId})
        window.livewire.emit('ChatBottom'+e.roomId)
    }
})

window.addEventListener('chat-scroll-top', e => {
    console.log('top event: room id => ' + e.roomId)
    if (window.livewire) {
        window.livewire.emit('ChatTop', { chatType : e.roomId});
        window.livewire.emit('ChatTop'+e.roomId)
    }
})

window.addEventListener('custom-scrolls', e => {
    const { containerId, side } = e
    if (window.livewire) {
        window.livewire.emit('scrollContent', { side: side, containerId : containerId});
    }
    // console.log(`${containerId}: ${side}`)
})

window.addEventListener('close-custom-select', e => {
    const { selectEl, selectId, shouldClose } = e
    // window.livewire.emit('close-custom-select', selectId)
    // console.log(selectEl, selectId, shouldClose)
})

window.addEventListener('tab-event', e => {
    const { tabsGroup, tabIndex } = e
    console.log(tabsGroup+'OpenTab'+tabIndex)
    if (window.livewire) {
        window.livewire.emit(tabsGroup+'OpenTab'+tabIndex);
    }

    // payment main mobile tabs
    // set tab type for customer or driver
    if (tabsGroup == 'payment-main-mobile') {
        const types = ['customer', 'driver']
        const input = document.querySelector('.modal-add-payment__type')
        if (input) {
            input.value = types[tabIndex]
        }

        console.log(input.value)
    }

    // Equalize height in tab payments
    if (tabsGroup === 'payment' && tabIndex === 0) {
        setTimeout(() => {
            CNS.$fns.equalizeHeights()
        }, 20)
    }
})

window.addEventListener('complex-lead-stack-open', event => {
    const { targetName } = event
    console.log('complex-lead-stack-open:', targetName)
    if (window.livewire) {
        window.livewire.emit(targetName+'OpenTab', null);
    }

    // Equalize height in tab payments
    if (targetName === 'payment') {
        setTimeout(() => {
            CNS.$fns.equalizeHeights()
        }, 20)
    }
})



const toastManager = new ToastManager({
    toastLifespan: 7000,
    topOffset: 50,
    spaceBetweenToasts: 10,
    toastTransition: .7
})

// warning, danger, success
Livewire.on('showAlert', (type, message, time) => {

    setTimeout(() => {
        toastManager.createToast(message, type)
    }, time)
})

Livewire.on('redirect', function (data) {
    window.open(data.url, '_blank'); // Відкриття URL у новій вкладці
});

Livewire.on('setSelectQueryAutoFocus', (name) => {
    const wraper = document.getElementById('search-wraper-'+name);
    setTimeout(()=> {
        if (wraper) {
            const input = wraper.getElementsByClassName("input")[0];
            input.focus();
        }
    }, 100);


})

Livewire.on('initChats', (roomId) => {

    CNS.$fns.initChats(roomId);

})

Livewire.on('moveToLastReadMessageinChat', (chatType, messageNumber, scrollToEndIfNotFound) => {
    console.log('scroll', chatType, messageNumber);
    CNS.$fns.scrollChatRoomToMessage(chatType, messageNumber, true);

});

Livewire.on('moveBottomById', (id) => {

    var element = document.getElementById(id);

    element.scrollTop = element.scrollHeight;

});

Livewire.on('moveTopById', (id) => {

    var element = document.getElementById(id);

    element.scrollTop = 0;

});

Livewire.on('updateTabsCounters', (chatId, counter) => {

    console.log('Tabs counter - ' + chatId + ' : ' + counter);
    window.CNS.$fns.updateMainTabCounter(chatId, counter);
    //CNS.$fns.scrollChatRoomToMessage(chatType, messageNumber, true);

});

Livewire.on('setSecondaryTabMessageCounterByIndex', (tabsGroupName, index, count) => {

    CNS.$fns.setSecondaryTabMessageCounterByIndex(tabsGroupName, index, count)

});

Livewire.on('setPrimaryTabMessageCounterByName', (name, count) => {

    CNS.$fns.setPrimaryTabMessageCounterByName(name, count)

});

Livewire.on('setPrimaryTabMessageCounterByIndex', (index, count) => {

    CNS.$fns.setPrimaryTabMessageCounterByIndex(index, count)

});

Livewire.on('reinitDatePicker', (className) => {

    CNS.$fns.reinitDatePicker('.'+className)

});

Livewire.on('equalizeHeights', (roomId) => {

    CNS.$fns.equalizeHeights()

})

Livewire.on('setNotificationCounter', ($counter) => {

    const notificationCounter = document.querySelector('#main-menu-counter');
    //console.log(notificationCounter);
    notificationCounter.innerHTML = $counter;

    const notificationTabCounter = document.querySelector('#notifications-tab__count-not_read');
    //console.log(notificationCounter);
    notificationTabCounter.innerHTML = $counter;

});

Livewire.on('setNotificationLeadsCounter', ($counter) => {

    const notificationTabCounter = document.querySelector('#notifications-tab__count-leads');
    //console.log(notificationCounter);
    notificationTabCounter.innerHTML = $counter;

});

Livewire.on('setPaymentMargin', (planPrim, planSec, expPrim, expSec, factPrim, factSec) => {

    window.CNS.$fns.setPaymentMargin(planPrim, planSec, expPrim, expSec, factPrim, factSec);

});

Livewire.on('copyToClipboard', ($blockId) => {
    console.log($blockId);
    let text = document.getElementById($blockId).innerHTML;

    navigator.clipboard.writeText(text).then(() => {
        console.log('Content copied to clipboard');
      },() => {
        console.error('Failed to copy');
      });
});

Livewire.on('copyToClipboardText', (text) => {

    navigator.clipboard.writeText(text).then(() => {
        console.log('Content text copied to clipboard');
      },() => {
        console.error('Failed to copy text');
      });
});

//document.querySelector(selector).click()

Livewire.on('showModal', (method) => {
    if (method == 'openModalQuickLead') {
        window.CNS.$fns.openModalQuickLead();
    }

    if (method == 'openModalAddressAdd') {
        window.CNS.$fns.openModaLoading();
    }

    if (method == 'openModalCargo') {
        window.CNS.$fns.openModalCargo();
    }

    if (method == 'openModalCollectiveCargo') {
        window.CNS.$fns.openModalCollectiveCargo();
    }

    if (method == 'openModalConditions') {
        window.CNS.$fns.openModalConditions();
    }

    if (method == 'openModalSendDocuments') {
        window.CNS.$fns.openModalSendDocuments();
    }

    if (method == 'openModalConfirmDelete') {
        window.CNS.$fns.openModalConfirm();
    }

    if (method == 'openModalChangeStatus') {
        window.CNS.$fns.openModalChangeStatus();
    }

    if (method == 'openModalCreateReturnLead') {
        window.CNS.$fns.openModalCreateReturnLead();
    }

    if (method == 'openModalTakeInWork') {
        window.CNS.$fns.openModalTakeInWork();
    }

    if (method == 'openModalCopyLead') {
        window.CNS.$fns.openModalCopyLead();
    }

    if (method == 'openModalLeadAccess') {
        window.CNS.$fns.openModalLeadAccess();
    }

    if (method == 'openModalLeadSupport') {
        window.CNS.$fns.openModalLeadSupport();
    }

    if (method == 'openModalCompanycreate') {
        window.CNS.$fns.openModalCompanycreate();
    }

    if (method == 'openModalContractConditions') {
        window.CNS.$fns.openModalContractConditions();
    }

    if (method == 'openModalLeadCancel') {
        window.CNS.$fns.openModalLeadCancel();
    }

    if (method == 'openModalConfirmLeadOrder') {
        window.CNS.$fns.openModalConfirmLeadOrder();
    }

    if (method == 'openModalConfirmDocumentAccount') {
        window.CNS.$fns.openModalConfirmDocumentAccount();
    }

    if (method == 'openModalConfirmDocumentAct') {
        window.CNS.$fns.openModalConfirmDocumentAct();
    }

    if (method == 'openModalConfirmDocumentExpenseCertificate') {
        window.CNS.$fns.openModalConfirmDocumentExpenseCertificate();
    }

    if (method == 'openModalEstimateCompany') {
        window.CNS.$fns.openModalEstimateCompany();
    }

    if (method == 'openModalCompanyDelivery') {
        window.CNS.$fns.openModalCompanyDelivery();
    }

    if (method == 'openModalShowFile') {
        window.CNS.$fns.openModalShowFile();
    }

    if (method == 'openModalManageContract') {
        window.CNS.$fns.openModalManageContract();
    }

    if (method == 'openModalManageContragent') {
        window.CNS.$fns.openModalManageContragent();
    }

    if (method == 'openModalSignFile') {
        window.CNS.$fns.openModalSignFile();
    }

    if (method == "openModalLeadDelivery") {
        window.CNS.$fns.openModalLeadDelivery();
    }

    if (method == "openModalLeadReceiving") {
        window.CNS.$fns.openModalLeadReceiving();
    }

    if (method == "openModalViewFileContent") {
        window.CNS.$fns.openModalViewFileContent();
    }
})

Livewire.on('openLeadTab', (tab) => {
    window.CNS.$fns.toggleComplexLeadStack(tab);
})

Livewire.on('closeModal', (method) => {

    if (method == 'closeModalQuickLead') {
        window.CNS.$fns.closeModalQuickLead();
    }

    if (method == 'closeModalAddressAdd') {
        window.CNS.$fns.closeModaLoading();
    }

    if (method == 'closeModalCargo') {
        window.CNS.$fns.closeModalCargo();
    }

    if (method == 'closeModalCollectiveCargo') {
        window.CNS.$fns.closeModalCollectiveCargo();
    }

    if (method == 'closeModalConditions') {
        window.CNS.$fns.closeModalConditions();
    }

    if (method == 'closeModalSendDocuments') {
        window.CNS.$fns.closeModalSendDocuments();
    }

    if (method == 'closeModalSearchMobile') {
        window.CNS.$fns.closeModalLeadsFilterMobile();
    }

    if (method == 'closeModalConfirmDelete') {
        window.CNS.$fns.closeModalConfirm();
    }

    if (method == 'closeModalChangeStatus') {
        window.CNS.$fns.closeModalChangeStatus();
    }

    if (method == 'closeModalCreateReturnLead') {
        window.CNS.$fns.closeModalCreateReturnLead();
    }

    if (method == 'closeModalTakeInWork') {
        window.CNS.$fns.closeModalTakeInWork();
    }

    if (method == 'closeModalCopyLead') {
        window.CNS.$fns.closeModalCopyLead();
    }

    if (method == 'closeModalLeadAccess') {
        window.CNS.$fns.closeModalLeadAccess();
    }

    if (method == 'closeModalLeadSupport') {
        window.CNS.$fns.closeModalLeadSupport();
    }

    if (method == 'closeModalCompanycreate') {
        window.CNS.$fns.closeModalCompanycreate();
    }

    if (method == 'closeModalLeadsFilter') {
        window.CNS.$fns.closeModalLeadsFilter();
    }

    if (method == 'closeModalLeadsSorter') {
        window.CNS.$fns.closeModalLeadsSorter();
    }

    if (method == 'closeModalContractConditions') {
        window.CNS.$fns.closeModalContractConditions();
    }

    if (method == 'closeModalLeadCancel') {
        window.CNS.$fns.closeModalLeadCancel();
    }

    if (method == 'closeModalConfirmLeadOrder') {
        window.CNS.$fns.closeModalConfirmLeadOrder();
    }

    if (method == 'closeModalConfirmDocumentAccount') {
        window.CNS.$fns.closeModalConfirmDocumentAccount();
    }

    if (method == 'closeModalConfirmDocumentAct') {
        window.CNS.$fns.closeModalConfirmDocumentAct();
    }

    if (method == 'closeModalConfirmDocumentExpenseCertificate') {
        window.CNS.$fns.closeModalConfirmDocumentExpenseCertificate();
    }

    if (method == 'closeModalEstimateCompany') {
        window.CNS.$fns.closeModalEstimateCompany();
    }

    if (method == 'closeModalCompanyDelivery') {
        window.CNS.$fns.closeModalCompanyDelivery();
    }

    if (method == 'closeModalShowFile') {
        window.CNS.$fns.closeModalShowFile();
    }

    if (method == 'closeModalManageContract') {
        window.CNS.$fns.closeModalManageContract();
    }

    if (method == 'closeModalManageContragent') {
        window.CNS.$fns.closeModalManageContragent();
    }

    if (method == 'closeModalSignFile') {
        window.CNS.$fns.closeModalSignFile();
    }

    if (method == "closeModalLeadDelivery") {
        window.CNS.$fns.closeModalLeadDelivery();
    }

    if (method == "closeModalLeadReceiving") {
        window.CNS.$fns.closeModalLeadReceiving();
    }

    if (method == "closeModalViewFileContent") {
        window.CNS.$fns.closeModalViewFileContent();
    }
})

Livewire.on('setAutoFocusById', (name) => {
    const wraper = document.getElementById(name);
    setTimeout(()=> {
        if (wraper) {
            //const input = wraper.getElementsByClassName("input")[0];
            wraper.focus();
        }
    }, 100);
})

// Scripts for copy file from clipboard in lead chats

var clipboardImageInputs = document.querySelectorAll('.past-clipboard-image');

//inputItem = document.getElementById('inputItem');

Array.from(clipboardImageInputs).forEach(imageInput => {

    imageInput.onpaste = function(pasteEvent) {

        const chatType = imageInput.dataset.chat;

        var item = pasteEvent.clipboardData.items[0];

        if (item.type.indexOf("image") === 0)
        {
            var blob = item.getAsFile();

            var reader = new FileReader();
            reader.onload = function(event) {
                //document.getElementById("base64Data").value = reader.result;
                Livewire.emit('clipboardFileUploaded'+chatType, reader.result);
            };

            reader.readAsDataURL(blob);
        }
    }

});

document.addEventListener("mousedown", function (e1) {
    if (e1.which === 2) {
      document.addEventListener("mouseup", function handler(e2) {
        if (e1.target === e2.target) {
          var e3 = new MouseEvent("middleclick", e2);
          e2.target.dispatchEvent(e3);
          document.removeEventListener("mouseup", handler);
        }
      });
    }
});


document.addEventListener("middleclick", function (e) {
    if (e.target.matches('.action-notification__link')) {
        e.preventDefault(); // Відміна стандартної дії посилання
        var dataValue = e.target.dataset.notification;
        Livewire.emit('middleClick', dataValue);
    }
});


var savePaymentButton = document.getElementById('lead-payment-all-save-desktop');

if (savePaymentButton) {
    savePaymentButton.onclick = function (){
        if (window.livewire) {
            window.livewire.emit('savePaymentTab');
        }
    }
}
